/**
 * Resume helper utilities
 */

/**
 * Get resume URLs (PDF and original) from a resume location
 * @param {string} resumeLocation - The Cloudinary resume location path
 * @param {object} options - Optional configuration
 * @param {boolean} options.withCacheBusting - Whether to add timestamp for cache-busting (default: false)
 * @returns {object} Object containing pdfUrl and originalUrl
 */
export const getResumeUrls = (resumeLocation, options = {}) => {
  if (!resumeLocation) {
    return { pdfUrl: null, originalUrl: null };
  }

  const { withCacheBusting = false } = options;
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUDNAME;

  // Check if the file is already a PDF or has no extension
  const isPdfFormat = /\.pdf$/i.test(resumeLocation);
  const hasNoExtension = !/\.[^/]+$/.test(resumeLocation);

  // Build PDF URL with optional cache-busting
  const versionParam = withCacheBusting ? `v${Date.now()}/` : "";
  const pdfUrl = `https://res.cloudinary.com/${cloudName}/image/upload/${versionParam}${resumeLocation}.pdf`;

  // Only provide original URL if file is not PDF and has an extension
  const originalUrl =
    isPdfFormat || hasNoExtension
      ? null
      : `https://res.cloudinary.com/${cloudName}/raw/upload/${versionParam}${resumeLocation}`;

  return { pdfUrl, originalUrl };
};
